<wbo-bi-view-header [restrictions]="restrictions" [rowsTruncated]="rowsTruncated" [columnsTruncated]="columnsTruncated"
                    [showRefresh]="showRefresh" (refresh)="refresh.next($event)"></wbo-bi-view-header>

<div class="toolbar">
    <fui-action [disabled]="!showEdit" (click)="edit.next($event)" [attr.title]="'wbo.common.button.edit' | translate">
        <fui-icon [height]="20" [icon]="'edit'" [width]="20" class="edit-icon"></fui-icon>
    </fui-action>

    <fui-action [disabled]="!showClone" (click)="clone.next($event)" [attr.title]="'wbo.common.button.clone' | translate">
        <fui-icon [height]="20" [icon]="'clone'" [width]="20" class="edit-icon"></fui-icon>
    </fui-action>

    <fui-action [disabled]="!showDelete" (click)="delete.next($event)" [attr.title]="'wbo.common.button.delete' | translate">
        <fui-icon [height]="20" [icon]="'delete'" [width]="20" class="edit-icon"></fui-icon>
    </fui-action>
</div>
